import { Button } from 'antd';
import PageLoader from 'components/Shared/PageLoader';
import PrintTemplate from 'components/Shared/PrintTicket/PrintTemplate';
import { IEventTickets } from 'interfaces/attendanceList';
import { IEvent } from 'interfaces/event';
import IUserToken from 'interfaces/tokens/userToken';
import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { Helmet } from 'react-helmet';
import { useRouteMatch } from 'react-router-dom';
import * as Rx from 'rxjs';
import RxOp from 'rxjs-operators';
import attendanceListService from 'services/attendanceList';
import authService from 'services/auth';
import ticketService from 'services/ticket';
import userService from 'services/userService';

interface RouteProps {
  attendance_id: string;
  id: string;
  is_gift: string;
}

const PrintTicketPage = () => {
  const [data, setData] = useState<IEventTickets[]>(null);
  const [event, setEvent] = useState<IEvent>(null);
  const [user, setUser] = useState<IUserToken>(null);
  const [eventImage, setEventImage] = useState<string>(null);
  const [isLoading, setIsLoading] = useState(false);
  const {
    params: { id, attendance_id, is_gift },
  } = useRouteMatch<RouteProps>();

  const attendancePrinted = (eventId: string, attendanceIds: string[]) => {
    ticketService.attendancePrinted(eventId, attendanceIds).subscribe();
  };

  useEffect(() => {
    if (!attendance_id) {
      setIsLoading(true);
      authService
        .getUser()
        .pipe(
          RxOp.switchMap(user => {
            if (user) {
              return Rx.of(user);
            }

            return authService.getProfile().pipe(RxOp.map(response => response.data));
          }),
          RxOp.first(),
          RxOp.logError(),
          RxOp.bindComponent(this),
        )
        .subscribe(
          user => {
            let isSupport = false;
            if (localStorage.getItem('isSupport') && localStorage.getItem('isSupport') === 'true') {
              isSupport = true;
            }
            userService.setUser({ isSupport, ...user });
            setUser({ isSupport, ...user });
          },
          err => {
            authService.handleErrorMessage(err);
          },
        );

      attendanceListService
        .getEventTickets(id)
        .pipe(RxOp.bindComponent(this), RxOp.logError())
        .subscribe(
          data => {
            const dataFiltered = data.filter(item => item.status !== 'locked' && item.status !== 'refunded');
            setData(dataFiltered);
          },
          err => {
            attendanceListService.handleErrorMessage(err);
          },
        );

      attendanceListService.getMyEvents().subscribe(
        events => {
          const event = events.find(event => {
            return event.id === id;
          });
          setEvent(event);
          setIsLoading(false);
        },
        err => {
          attendanceListService.handleErrorMessage(err);
          setIsLoading(false);
        },
      );
    }

    if (attendance_id) {
      setIsLoading(true);
      attendanceListService.getParticipantData(id, attendance_id).subscribe(
        data => {
          const dataFiltered = data.filter((item: any) => item.status !== 'locked' && item.status !== 'refunded');
          setEvent(data[0]);
          setEventImage(process.env.REACT_APP_CDN_URL + data[0].image_path);
          setData(dataFiltered);
          setIsLoading(false);
        },
        err => {
          setIsLoading(false);
          attendanceListService.handleErrorMessage(err);
        },
      );
    }
  }, [attendance_id, id]);

  let ticketData =
    user && data
      ? data.filter(
          item =>
            (is_gift === '1' && item.first_cli_cod !== user.cli_cod && item.cli_cod === user.cli_cod) ||
            is_gift === '0',
        )
      : [];

  if (attendance_id !== undefined && data) {
    ticketData = data.filter(item => attendance_id === item.attendance_id);
  }

  if (isLoading) {
    return <PageLoader />;
  }

  return (
    <>
      {event && eventImage && (
        <Helmet>
          <title>Blinket | {event.title}</title>
          <meta property='og:image' content={eventImage} />
          <meta property='og:title' content={event.title} />
        </Helmet>
      )}
      <div style={{ backgroundColor: '#FFFFFF' }}>
        <div className='noprint'>
          <Button
            className='noprint'
            style={{ margin: '20px 39px 18px 39px' }}
            onClick={() => {
              try {
                attendancePrinted(event['event_id'], [event['attendance_id']]);
                document.execCommand('print', false, null);
              } catch {
                window.print();
              }
            }}
            type='primary'
          >
            {isMobile ? 'Baixar' : 'Imprimir'}
          </Button>
        </div>
        <div
          style={{
            paddingLeft: 10,
            backgroundColor: '#FFFFFF',
          }}
          id='tickets-to-print'
        >
          <div
            style={{
              backgroundColor: '#FFFFF',
            }}
          >
            <PrintTemplate data={ticketData} event={event} eventImage={eventImage} />
          </div>
        </div>
      </div>
    </>
  );
};

export default PrintTicketPage;
